// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchpushmsg[data-v-0f5ad38a]{display:flex;justify-content:start}.el-input[data-v-0f5ad38a]{width:200px}.irrigat[data-v-0f5ad38a]{padding:5px;background-color:#fff;margin:20px}", ""]);
// Exports
module.exports = exports;
